/**
 * Product Card Reviews - Displays review count next to stars
 * Watches for Yotpo widget data to be populated and extracts review count from aria-label
 */

/**
 * Extracts the number of reviews from the Yotpo widget's aria-label
 * @param {Element} widget - The Yotpo widget element
 * @returns {number|null} The number of reviews, or null if not found
 */
function extractReviewCount(widget) {
  const ratingSpan = widget.querySelector('span[role="img"][aria-label]');
  if (!ratingSpan) return null;

  const ariaLabel = ratingSpan.getAttribute('aria-label');
  if (!ariaLabel) return null;

  const match = ariaLabel.match(/in total (\d+) review/i);
  return match ? parseInt(match[1], 10) : null;
}

/**
 * Creates and displays the review count element
 * @param {Element} container - The yotpo-star-rating container
 * @param {number} count - The number of reviews
 */
function displayReviewCount(container, count) {
  const existingCount = container.querySelector('.yotpo-review-count');
  if (existingCount) {
    existingCount.textContent = `(${count})`;
    return;
  }

  const countElement = document.createElement('span');
  countElement.className = 'yotpo-review-count';
  countElement.textContent = `(${count})`;
  container.appendChild(countElement);
}

/**
 * Initializes review count display for a product card
 * @param {Element} card - The product card element
 */
function initProductCardReviews(card) {
  const container = card.querySelector('.yotpo-star-rating');
  if (!container) return;

  const widget = container.querySelector('.yotpo-widget-instance');
  if (!widget) return;

  let observer = null;

  const checkAndDisplayCount = () => {
    const count = extractReviewCount(widget);
    if (count !== null) {
      displayReviewCount(container, count);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  };

  const ratingSpan = widget.querySelector('span[role="img"][aria-label]');
  if (ratingSpan) {
    checkAndDisplayCount();
  } else {
    observer = new MutationObserver(() => {
      checkAndDisplayCount();
    });
    observer.observe(widget, { childList: true, subtree: true });
  }
}

/**
 * Initializes all product cards on the page
 */
function initAllProductCards() {
  const cards = document.querySelectorAll('.product-card');
  cards.forEach(initProductCardReviews);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllProductCards);
} else {
  initAllProductCards();
}